module.exports = __webpack_public_path__ + "static/media/2018-sh.e0620cbd.png";